import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { Logger } from './logger.service';

@Injectable()
export class HttpLoggingInterceptor implements HttpInterceptor {
  constructor(private logger: Logger) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const started = performance.now();
    this.logger.debug('HTTP →', { method: req.method, url: req.urlWithParams });

    return next.handle(req).pipe(
      tap({
        next: () => {
          const ms = Math.round(performance.now() - started);
          this.logger.info('HTTP ✓', { url: req.urlWithParams, ms });
        },
        error: (err: unknown) => {
          const ms = Math.round(performance.now() - started);
          if (err instanceof HttpErrorResponse) {
            this.logger.error('HTTP ✗', {
              url: req.urlWithParams,
              status: err.status,
              statusText: err.statusText,
              ms,
              body: err.error
            });
          } else {
            this.logger.error('HTTP ✗ unknown', { url: req.urlWithParams, ms, err });
          }
        }
      })
    );
  }
}
